/**
 * Les colonnes issues du fichier importe.
 *
 * 🚨 Kevin, 2026-09-30 : « civilite », « legal », « poste occupe », « nom de
 * la liste »… Chaque colonne du fichier devenait une colonne du tableau, et
 * s'affichait sans que personne l'ait demandee. Un fichier de prospection en
 * porte des dizaines ; le tableau devenait illisible a cause du fichier, pas
 * a cause d'un choix.
 *
 * Elles sont donc masquees tant qu'on ne les a pas demandees, et restent a un
 * clic dans le menu « Colonnes ». La liste des colonnes DISPONIBLES ne change
 * pas : c'est leur affichage par defaut qui s'inverse.
 */

export interface EntreeColonne {
  id: string;
  label?: string;
  visible?: boolean;
}

const PREFIXE = 'custom:';

/** Ce que l'utilisateur a explicitement decide, par cle. */
function decisions(columnConfig: unknown): Map<string, boolean> {
  const explicites = new Map<string, boolean>();
  const entrees = Array.isArray(columnConfig) ? (columnConfig as EntreeColonne[]) : [];
  for (const entree of entrees) {
    if (typeof entree?.id === 'string' && entree.id.startsWith(PREFIXE)) {
      explicites.set(entree.id.slice(PREFIXE.length), !!entree.visible);
    }
  }
  return explicites;
}

/** Les colonnes du fichier a afficher : celles qu'on a demandees, et elles seules. */
export function visibleCustomColumns(available: string[], columnConfig: unknown): string[] {
  const explicites = decisions(columnConfig);
  return available.filter((cle) => explicites.get(cle) === true);
}

/** Afficher ou masquer une colonne du fichier, en conservant les autres choix. */
export function toggleCustomColumn(columnConfig: unknown, key: string): EntreeColonne[] {
  const entrees = Array.isArray(columnConfig) ? [...(columnConfig as EntreeColonne[])] : [];
  const id = `${PREFIXE}${key}`;
  const index = entrees.findIndex((e) => e?.id === id);
  if (index === -1) {
    // Absente de la configuration : elle etait masquee, le clic l'affiche.
    entrees.push({ id, label: key, visible: true });
  } else {
    entrees[index] = { ...entrees[index], id, visible: !entrees[index]?.visible };
  }
  return entrees;
}
